.card {
  background-color: white;
  margin-bottom: 3rem;
}
